import { IonPage } from '@ionic/react'
import { useParams } from 'react-router-dom'

import { useGetUnitTriggers } from '@apps-common/apis/portal/trigger'
import { useGetUnitGenericDetails } from '@apps-common/apis/portal/unit'
import { Triggers } from '@apps-common/apps/portal/pages/units/pages/manage/pages/triggers/components'
import { PullRefresh } from '@apps-common/components/common'
import { AccountNoTitle, PageTitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundLg } from '@apps-common/components/elements'
import { Header, LayoutContainer, LayoutPadding, VertSpacerXl } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { commonIcons } from '@apps-common/config/icons'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { ROUTE_UNIT_TRIGGERS } from '@apps-radionet-portal/config/private-routes'
import { invalidateTriggerQueries } from '../../../../../../../../lib/invalidateTriggerQueries'
import { useTriggerModifyModal } from './hooks/useTriggerModifyModal'
import { TriggerModifyModal } from './modals/trigger-modify-modal/TriggerModifyModal'

export const TriggersPage: React.FC = () => {
  const { status, unitId } = useParams<{ status: string; unitId: string }>()
  const { data: unit, isLoading: unitIsLoading, isError: unitIsError } = useGetUnitGenericDetails({ status, unitId })

  const { accountNo, productId } = unit || {}

  const { present } = useTriggerModifyModal({
    status,
    unitId,
    productId: productId || '',
    triggerId: undefined
  })

  const {
    data: triggers,
    isLoading: triggersIsLoading,
    isRefetching: triggersIsRefetching,
    isError: triggersIsError,
    refetch: triggersRefetch
  } = useGetUnitTriggers({ config: { enabled: unitId !== undefined }, unitId })

  const loading = unitIsLoading || unitIsError || triggersIsLoading || triggersIsError

  return (
    <IonPage>
      <Header classes='!max-w-[1200px]'>
        <Navbar showBack transparent icons={[]} />
        <Breadcrumbs route={ROUTE_UNIT_TRIGGERS} />
        <div className='flex items-center justify-between'>
          <PageTitle classes='flex items-center justify-start gap-[10px]'>
            <span className='block'>Control Triggers</span>
            <AccountNoTitle text={`(Acc# ${accountNo})`} />
          </PageTitle>

          <ModalButton
            component={TriggerModifyModal}
            disabled={false}
            componentProps={{
              status,
              unitId,
              productId
            }}
            classes='w-full'
            confirmCallback={() => {
              invalidateTriggerQueries(undefined, unitId)
            }}
            enterAnimation={modalSlideUpEnterAnimation}
            leaveAnimation={modalSlideUpLeaveAnimation}
            tooltip={{ id: 'device-triggers-add-new', place: 'bottom', message: 'Add new trigger' }}
          >
            <ButtonRoundLg type='div' className='action-success'>
              <commonIcons.add className='text-[1.35rem]' />
            </ButtonRoundLg>
          </ModalButton>
        </div>
      </Header>
      <LayoutContainer>
        <LayoutPadding classes='pt-[20px] md:pt-[20px]'>
          <PullRefresh loading={triggersIsRefetching} callback={() => triggersRefetch()} />
          <Triggers status={status} unitId={unitId} productId={productId || ''} loading={loading} data={triggers || []} />
        </LayoutPadding>
        <VertSpacerXl />
      </LayoutContainer>
    </IonPage>
  )
}
